import cn from "classnames";
import { IconBaseProps } from "react-icons";
import { AiFillApi, AiOutlineSend, AiOutlineSplitCells } from "react-icons/ai";
import { BiCrosshair, BiDetail, BiStats, BiTargetLock } from "react-icons/bi";
import { BsClockHistory, BsFiletypeJson, BsFiletypeRaw, BsGrid3X3Gap, BsSliders, BsThreeDots } from "react-icons/bs";
import { CgArrowsMergeAltV } from "react-icons/cg";
import {
    FaArrowAltCircleUp,
    FaBars,
    FaCalendar,
    FaCaretDown,
    FaCaretLeft,
    FaCaretRight,
    FaCaretUp,
    FaChartLine,
    FaCheckCircle,
    FaChevronLeft,
    FaChevronRight,
    FaClipboard,
    FaClock,
    FaCogs,
    FaDownload,
    FaDrawPolygon,
    FaEdit,
    FaExclamationCircle,
    FaExclamationTriangle,
    FaExpand,
    FaEye,
    FaEyeSlash,
    FaInfoCircle,
    FaLayerGroup,
    FaLock,
    FaMapMarker,
    FaNetworkWired,
    FaParking,
    FaPause,
    FaPencilAlt,
    FaPlay,
    FaPlusCircle,
    FaPowerOff,
    FaPrint,
    FaRegObjectGroup,
    FaRoute,
    FaRuler,
    FaSatelliteDish,
    FaSearch,
    FaSort,
    FaSortDown,
    FaSortUp,
    FaSpinner,
    FaStopwatch,
    FaTablet,
    FaTimes,
    FaTimesCircle,
    FaTrash,
    FaTruck,
    FaUsers,
    FaVideo
} from "react-icons/fa";
import { FaArrowRight, FaArrowRightFromBracket, FaArrowRightToBracket, FaArrowsLeftRight, FaArrowsUpDown, FaTimeline, FaUpRightFromSquare, FaCircleCheck, FaCircleExclamation, FaArrowLeft } from "react-icons/fa6";
import { GrPowerReset, GrRefresh } from "react-icons/gr";
import { ImExit, ImPlus } from "react-icons/im";
import { IoAddOutline, IoBusinessOutline, IoDocumentText, IoEnter, IoExit, IoHardwareChipOutline, IoLocationOutline, IoPlaySkipForward, IoSaveOutline, IoSettingsOutline, IoSettingsSharp } from "react-icons/io5";
import { MdAccountCircle, MdCellTower, MdDashboard, MdExpandMore, MdLightbulbOutline, MdMail, MdOutlineComputer, MdOutlinePlaylistRemove, MdOutlineQuestionMark, MdPhotoCamera, MdReport, MdSignalCellularAlt, MdWaterDrop } from "react-icons/md";
import { PiFileVideo, PiMouseRightClickFill, PiMouseSimple } from "react-icons/pi";
import { RiFileDamageLine, RiMoneyDollarCircleLine } from "react-icons/ri";
import { TbCalendarBolt, TbCloud, TbCloudLockOpen, TbEdit, TbLayoutSidebarLeftExpand, TbLayoutSidebarRightExpand, TbMessage2Code, TbLine } from "react-icons/tb";
import { TiArrowBack, TiMessageTyping } from "react-icons/ti";

export const Icons = {
    Api: AiFillApi,
    Dashboard: MdDashboard,
    ArrowBack: TiArrowBack,
    ArrowsUpDown: FaArrowsUpDown,
    ArrowsLeftRight: FaArrowsLeftRight,
    ArrowRight: FaArrowRight,
    ArrowLeft: FaArrowLeft,
    Bars: FaBars,
    Chart: FaChartLine,
    MouseScroll: PiMouseSimple,
    Event: TbCalendarBolt,
    Expand: MdExpandMore,
    Line: TbLine,
    RightMouseButton: PiMouseRightClickFill,
    Clipboard: FaClipboard,
    CircleSuccess: FaCircleCheck,
    CircleError: FaCircleExclamation,
    Download: FaDownload,
    Edit: FaEdit,
    FullScreen: FaExpand,
    PlusCircle: FaPlusCircle,
    Play: FaPlay,
    Pause: FaPause,
    Refresh: GrRefresh,
    Trash: FaTrash,
    Timeline: FaTimeline,
    Plus: ImPlus,
    Close: FaTimesCircle,
    Search: FaSearch,
    OverflowMenu: BsThreeDots,
    Pencil: FaPencilAlt,
    Eye: FaEye,
    EyeSlash: FaEyeSlash,
    Show: FaEye,
    Hide: FaEyeSlash,
    OpenModal: FaUpRightFromSquare,
    SortUp: FaSortUp,
    SortDown: FaSortDown,
    UnSorted: FaSort,
    Filter: BsSliders,
    Profile: MdAccountCircle,
    Spinner: FaSpinner,
    CaretDown: FaCaretDown,
    CaretUp: FaCaretUp,
    CaretRight: FaCaretRight,
    CaretLeft: FaCaretLeft,
    Calendar: FaCalendar,
    Logout: ImExit,
    Send: AiOutlineSend,
    OpenPort: TbCloudLockOpen,
    Cloud: TbCloud,
    NetworkWired: FaNetworkWired,
    MessageArrows: TbMessage2Code,
    Truck: FaTruck,
    Satellite: FaSatelliteDish,
    Clock: FaClock,
    Parking: FaParking,
    StopWatch: FaStopwatch,
    Entry: IoEnter,
    Exit: IoExit,
    Details: BiDetail,
    Settings: IoSettingsSharp,
    Target: BiTargetLock,
    Route: FaRoute,
    Photo: MdPhotoCamera,
    History: BsClockHistory,
    StatsDots: BiStats,
    Message: TiMessageTyping,
    Users: FaUsers,
    Warning: FaExclamationCircle,
    Info: FaInfoCircle,
    Error: FaTimesCircle,
    Success: FaCheckCircle,
    Times: FaTimes,
    Page404: RiFileDamageLine,
    Reset: GrPowerReset,
    PowerOff: FaPowerOff,
    Upgrade: FaArrowAltCircleUp,
    Report: MdReport,
    ObjectGroup: FaRegObjectGroup,
    MapMarker: FaMapMarker,
    LayerGroup: FaLayerGroup,
    Ruler: FaRuler,
    DrawPolygon: FaDrawPolygon,
    Video: FaVideo,
    Lock: FaLock,
    SplitCells: AiOutlineSplitCells,
    NavTruck: FaTruck,
    NavRadar: (props: IconBaseProps) => FaTablet({ ...props, className: cn(props.className, "rotate-180") }),
    NavSettings: FaCogs,
    ChevronRight: FaChevronRight,
    ChevronLeft: FaChevronLeft,
    JsonFile: BsFiletypeJson,
    VideoFile: PiFileVideo,
    ArrowRightFromBracket: FaArrowRightFromBracket,
    ArrowRightToBracket: FaArrowRightToBracket,
    MergeVertical: CgArrowsMergeAltV,
    ListRemove: MdOutlinePlaylistRemove,
    BinaryFile: BsFiletypeRaw,
    AlertTriangle: FaExclamationTriangle,
    Grid3x3: BsGrid3X3Gap,
    Save: IoSaveOutline,
    SettingsOutline: IoSettingsOutline,
    PlaySkipForward: IoPlaySkipForward,
    BusinessOutline: IoBusinessOutline,
    AddOutline: IoAddOutline,
    LocationOutline: IoLocationOutline,
    LightbulbOutline: MdLightbulbOutline,
    QuestionMarkCircleOutline: MdOutlineQuestionMark,
    DocumentText: IoDocumentText,
    HardwareChipOutline: IoHardwareChipOutline,
    ComputerDesktopOutline: MdOutlineComputer,
    Mail: MdMail,
    Cellular: MdCellTower,
    CellSignal: MdSignalCellularAlt,
    Humidity: MdWaterDrop,
    ExpandTray: TbLayoutSidebarRightExpand,
    CollapseTray: TbLayoutSidebarLeftExpand,
    TrayEdit: TbEdit,
    DollarSign: RiMoneyDollarCircleLine,
    Print: FaPrint,
    Crosshair: BiCrosshair,
};
